"use client";

import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Sarah Jenkins",
  role: "Homeowner",
  avatar: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_sarah_j.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_sarah_j.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_sarah_j.png-wvc-sizes",
    alt: "Sarah Jenkins"
  },
  rating: 5,
  review: "I was really worried about the mess a roof replacement would make, but the Eagle Exteriors crew was incredible. They finished so quickly and honestly, my yard looked cleaner after they left than before they started! So happy with the new roof."
}, {
  id: 2,
  name: "Michael Chen",
  role: "Property Manager",
  avatar: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_michael_c.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_michael_c.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_michael_c.png-wvc-sizes",
    alt: "Michael Chen"
  },
  rating: 5,
  review: "We've used them for multiple properties now. Their attention to detail and commitment to using high-quality materials really sets them apart from other contractors we've worked with."
}, {
  id: 3,
  name: "Emily Rodriguez",
  role: "Local Business Owner",
  avatar: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_emily_r.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_emily_r.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_emily_r.png-wvc-sizes",
    alt: "Emily Rodriguez"
  },
  rating: 5,
  review: "After the recent storm, we needed immediate siding repairs. They responded quickly, provided a fair quote, and completed the work ahead of schedule. Fantastic customer service!"
}, {
  id: 4,
  name: "David Thompson",
  role: "Homeowner",
  avatar: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_david_t.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_david_t.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/avatar_david_t.png-wvc-sizes",
    alt: "David Thompson"
  },
  rating: 5,
  review: "The new windows have completely transformed the look of our house and significantly reduced our energy bills. The installation team was courteous and very efficient."
}];
export default function CustomerTestimonials() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: carouselRef,
    isVisible: isCarouselVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return null;
}